import { fetchShopList, fetchShopDetailBranch } from '@/api';

const namespaced = true;

const state = {
	shopList: [],
	shopDetail: {},
	shopDetailBranch: {},
};

const getters = {
	shopList(state) {
		return state.shopList;
	},
	shopDetail(state) {
		return state.shopDetail;
	},
	shopDetailBranch(state) {
		return state.shopDetailBranch;
	},
};

const mutations = {
	getShopList(state, { page, list }) {
		if (page === undefined || list === undefined) return;

		if (page === 1) state.shopList = [...list];

		if (page > 1) state.shopList = [...state.shopList, ...list];
	},
	initShopList(state) {
		state.shopList = [];
	},
	getShopDetail(state, item) {
		state.shopDetail = item;
	},
	getShopDetailBranch(state, branch) {
		state.shopDetailBranch = branch;
	},
};

const actions = {
	getShopList({ commit }, payload) {
		return fetchShopList(payload)
			.then(response => {
				commit('getShopList', response.data);
				return response;
			})
			.catch(error => {
				console.dir(error);
				return error;
			});
	},
	initShopList({ commit }) {
		commit('initShopList');
	},
	getShopDetail({ commit }, payload) {
		commit('getShopDetail', payload);
	},
	getShopDetailBranch({ commit }, payload) {
		return fetchShopDetailBranch(payload)
			.then(({ data }) => {
				commit('getShopDetailBranch', data.branch);
				return data;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
